import { App } from 'vue';
// 自动注册组件
export const asyncComponent = function (app: App<Element>): void {
    const modules = import.meta.glob('../components/*.vue');
    Object.keys(modules).forEach((key: string) => {
        const filePathArr = key.split('/'),
            fileName = filePathArr[filePathArr.length - 1].split('.')[0];
        //@ts-ignore
        const AsyncComponent = defineAsyncComponent(modules[key]);
        app.component(fileName.length > 10 ? fileName : fileName + '-component', AsyncComponent);
    });
};
export const openLink = (url: string, target: string = '_blank') => {
    if (!url) return;
    window.open(url, target);
};
